<template>
  <div class='opc-cart-item__text first-capitalize'>
    <slot>
      <vloader v-if='isZuoraOutage' :loading='loading' :value='zuoraOutageChargeDate' />
      <template v-else>
        <span v-if="nextChargeDate.isVaryByItem">
          {{ $t('billing.order_summary.next_charge_date_vary') }}
        </span>
        <span v-else>
          {{ $t('billing.order_summary.next_charge_date') + ' ' }}
          <vloader :loading='loading' :value='chargeDate' />
        </span>
      </template>
    </slot>
  </div>
</template>
<script>
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';
import { mapGetters } from 'vuex';
import nextMixin from '@/views/config/shopping-cart/nextMixin';
import { BILLING_CYCLE } from '@/common/constants';
import { dateTimeFormat } from '@/utils/dateformat';

export default {
  mixins: [nextMixin],
  components: { vloader },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    billingCycle: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['nextChargeDate', 'isZuoraOutage', 'isPreventCBA_A2M']),
    chargeDate() {
      return this.nextDateFromServer || this.mx__deprecated__nextDate(new Date(), this.billingCycle, true);
    },
    zuoraOutageChargeDate() {
      return this.$t('billing.zuoraoutage.expire_date', [this.chargeDate]);
    },
    getNextDateFromServerPendingPlanList() {
      const currentPendingPlan = this.nextChargeDate?.pendingPlanList?.find((p) => p.oldPlanCode === this.currentEditPlan?.plan_code);
      const futureEffectiveDate = currentPendingPlan?.futureEffectiveDate;
      if (currentPendingPlan && futureEffectiveDate) {
        return dateTimeFormat(futureEffectiveDate);
      }
      return null;
    },
    nextDateFromServer() {
      if (this.isBizDowngradeToProAnnualBilledMonthly && this.getNextDateFromServerPendingPlanList) {
        return this.getNextDateFromServerPendingPlanList;
      }

      const dateKey = {
        [BILLING_CYCLE.MONTHLY]: 'nextMonthlyDate',
        [BILLING_CYCLE.ANNUAL_TERM_MONTHLY]: (
          this.isPreventCBA_A2M && 'nextAnnualDate'
          ||
          'nextMonthlyDate'
        ),
        [BILLING_CYCLE.ANNUAL]: 'nextAnnualDate',
        [BILLING_CYCLE.QUARTERLY]: 'nextQuarterlyDate',
        [BILLING_CYCLE.TWO_YEARS]: 'nextTwoYearsDate',
        [BILLING_CYCLE.THREE_YEARS]: 'nextThreeYearsDate',
      }[this.billingCycle];
      const nextDate = this.nextChargeDate[dateKey];
      if (nextDate) {
        return dateTimeFormat(nextDate);
      }
      return null;
    },
  },
};
</script>
